// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"c2-z"};